import {observable, asFlat} from 'mobx';
import PortalStore from '../module_biz/portal/store/PortalStore';


export default {
    PortalStore: new PortalStore(),
};